import { render, staticRenderFns } from "./UCTab.vue?vue&type=template&id=4a800956&scoped=true&"
import script from "./UCTab.vue?vue&type=script&lang=ts&"
export * from "./UCTab.vue?vue&type=script&lang=ts&"
import style0 from "./UCTab.vue?vue&type=style&index=0&id=4a800956&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a800956",
  null
  
)

export default component.exports